<template>
    <div>
        <v-layout row align-center justify-space-between class="header report-header" v-if="activeBot">
            <v-btn dark outline flat :to="'/bot/' + activeBot.code" class="report-back-btn">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px" class="report-title">Conversation Types Report</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer" class="report-bot-list">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile
                                v-for="bot in botList"
                                :key="bot.code"
                                @click="selectBot(bot)"
                                :class="activeBot.code === bot.code ? 'active' : ''"
                            >
                                <v-list-tile-title>{{ bot.name }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-layout wrap class="pa-3">
            <v-flex xs4 class="chart-wrapper pb-3">
                <v-layout class="mb-3">
                    <div class="pl-2 pt-1">Total message: {{total}}</div>
                    <v-spacer></v-spacer>
                    <TimeRangePicker ref="TimeRangePicker" v-model="timeRange"></TimeRangePicker>
                </v-layout>
                <PieChart ref="PieChart"></PieChart>
            </v-flex>
        </v-layout>

    </div>
</template>

<script>
import BotService from "@/services/bot.service";
import VueChart from "vue-chartjs";
import TimeRangePicker from "@/modules/fptai/components/TimeRangePicker";

export default {
    name: "ConversationTypesReport",
    components: { TimeRangePicker, PieChart: VueChart.Pie },
    data () {
        return {
            timeRange: 'thisMonth',
            activeBot: null,
            botList: [],
            total: 0
        }
    },
    methods: {
        backToBot () {
            this.$router.push('/bot/' + this.activeBot.code)
        },
        selectBot (bot) {
            this.$router.push(`/bot/${bot.code}/conversation-types-report`)
        },
        changeBot () {
            new Promise(resolve => {
                if (this.botList.length > 0) {
                    resolve(this.botList)
                } else if (this.$store.state.botList.length > 0) {
                    resolve(this.$store.state.botList)
                } else {
                    BotService.getAllBot().then(
                        result => resolve(result.data),
                        this.$AppService.handleRequestError()
                    )
                }
            }).then(
                botList => {
                    this.botList = botList
                    let botCode = this.$route.params.botCode
                    this.activeBot = this.botList.find(bot => bot.code === botCode)
                    if (this.activeBot) {
                        this.getData()
                    } else {
                        this.$AppService.toastError('incorrect bot code')
                    }
                }
            )
        },
        getData () {
            BotService.getConversationTypesReport(
                this.activeBot.code,
                this.$refs.TimeRangePicker.getTimestamp()
            ).then(
                result => {
                    let data = result.data
                    if (!this.$refs.PieChart) {
                        return
                    }
                    data = Object.values(data)
                    data.forEach(item => this.total += item.count)
                    this.$refs.PieChart.renderChart({
                        labels: data.map(item => item.label),
                        datasets: [{
                            backgroundColor: this.$utils.colorSamples,
                            borderWidth: 1,
                            data: data.map(item => item.count)
                        }]
                    }, {
                        responsive: true,
                        maintainAspectRatio: false,
                        title: {
                            display: false
                        },
                        legend: {
                            display: true,
                            position: 'bottom',
                            align: 'center'
                        }
                    })
                },
                this.$AppService.handleRequestError()
            )
        }
    },
    watch: {
        '$route.params.botCode': {
            immediate: true,
            handler: function () {
                this.changeBot()
            }
        },
        timeRange: 'getData'
    }
}
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .header {
        background: #2a4e69;
        color: #fff;
        padding: 0 15px;
    }

    .chart-wrapper {
        border: 1px solid #dfdfe3;
        border-radius: 5px;
    }

</style>
